export const reducerHelper = (state, type, data, reqState) => {
    return {
        ...state,
        [type]: {
            data,
            state: reqState
        }
    };
}